import { gql } from '@apollo/client';
const ADD_PRODUCT_CONTINENT = gql `
  mutation AddProductContinent($name: String!, $description: String, $thumbnail: String) {
    addProductContinent(name: $name, description: $description, thumbnail: $thumbnail) {
      productContinent {
        id
        name
        description
        thumbnail
      }
    }
  }
`;
export default ADD_PRODUCT_CONTINENT;
